module.exports = __webpack_public_path__ + "static/media/orat-img-003.548302d2.jpg";